import React, { useEffect, useState } from "react";
import {
  Routes,
  Route,
  BrowserRouter,
  Outlet,
  Navigate,
} from "react-router-dom";
import Login from "../pages/Login";
import Layout from "../components/Layout";
import { useSelector } from "react-redux";
import { authStateChanged } from "../api/auth";
import SplashScreen from "../pages/SplashScreen";
import Dashboard from "../pages/Dashboard";
import Blog from "../pages/Blog";
import Settings from "../pages/Settings";

const Routers = () => {
  const { admin } = useSelector((state) => state.admin);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      setLoading(true);
      await authStateChanged();
      setLoading(false);
    })();
  }, []);

  const PrivateWrapper = () => {
    return admin ? (
      <Layout>
        <Outlet />
      </Layout>
    ) : (
      <Navigate to="/login" />
    );
  };

  const AuthWrapper = () => {
    return !admin ? <Outlet /> : <Navigate to="/" />;
  };

  return (
    <BrowserRouter>
      {loading ? (
        <SplashScreen />
      ) : (
        <Routes>
          <Route element={<PrivateWrapper />}>
            <Route path="/" element={<Dashboard />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/settings" element={<Settings />} />
            <Route path="*" element={<Dashboard />} />
          </Route>
          <Route element={<AuthWrapper />}>
            <Route path="/login" element={<Login />} />
            <Route path="*" element={<Login />} />
          </Route>
        </Routes>
      )}
    </BrowserRouter>
  );
};

export default Routers;
